export const LOAD_NATIONALITIES = 'LOAD_NATIONALITIES'

